<template>
  <div style="position: relative;">
    <k-data-table :headers="headers" :items="AccountsList" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="headerCell" slot-scope="props">
          <div v-if="props.header.text == 'State'">
            <k-menu
            offset-y
            :close-on-content-click="false">
                <template slot="activator" slot-scope="{ on }" style="padding: 20px;">
                  <k-btn flat v-on="on">
                    <span style="display: flex; align-items: center;">
                      <div style="margin-right: 25px; margin-left: 35px;">Type</div>
                      <k-icon small>filter_list</k-icon>
                    </span>
                    </k-btn>
                </template>
                <div style="padding: 10px; height: 80px;">
                  <div style="padding: 0px; margin: 0px;">
                    <span>
                      <k-checkbox
                        v-model="state_filters"
                        label="Active"
                        input-value="active"
                        color="deep-orange"
                        style="padding: 0px; margin: 0px; height: 28px;"
                        hide-details
                      ></k-checkbox>
                    </span>
                  </div>
                  <div style="padding: 0px; margin: 0px;">
                    <span>
                      <k-checkbox
                        v-model="state_filters"
                        label="Archived"
                        input-value="archived"
                        color="deep-orange"
                        style="padding: 0px; margin: 0px; height: 28px;"
                        hide-details
                      ></k-checkbox>
                    </span>
                  </div>
                </div>
            </k-menu>
          </div>

          <span v-else>
              <td>{{ props.header.text }}</td>
          </span>
      </template>

      <template slot="items" slot-scope="props">
        <tr @click.stop="open_edit_account(props.item.id)" :class="{'grey--text': props.item.state == 'archived'}" :style="{background: (props.item.state == 'archived' ? $dark() ? '#616161' : '#f5f5f5' : '')}">
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.surname }}</td>
          <td>{{ props.item.meta.company || "" }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.state }}</td>
        </tr>
      </template>
    </k-data-table>
    <action-buttons @add="open_add_account"></action-buttons>
  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import ActionButtons from '@/components/ActionButtons.vue'

export default {
  components: {
    ActionButtons
  },
  filters: datelib,
  data () {
    return {
      headers: [
        { text: 'Email', value: 'email', align: 'left' },
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Surname', value: 'surname', align: 'left' },
        { text: 'Company', value: 'company', align: 'left' },
        { text: 'Type', value: 'type', align: 'left' },
        { text: 'State', value: 'state', align: 'left', sortable: false}
      ],
      pagination: {
        sortBy: 'id',
        descending: false,
        rowsPerPage: 25
      },
      state_filters: ['active']
    }
  },
  computed: {
    search_text () {
      return this.$store.state.search_text;
    },
    AccountsList () {
      var ret = Object.values(this.$store.state.accounts);
      var search = (this.search_text || "").toLowerCase();
      if(this.state_filters.length > 0) {
        ret = _.filter(ret, (account) => {
          return this.state_filters.indexOf(account.state) != -1;
        });
      }
      if (search.length > 0) {
        ret = _.filter(ret, function(account) {
          ret = false;
          if (account.email.toLowerCase().includes(search)) ret = true;
          if ((account.name||"").toLowerCase().includes(search)) ret = true;
          if ((account.surname||"").toLowerCase().includes(search)) ret = true;
          if ((account.meta.company||"").toLowerCase().includes(search)) ret = true;
          if (account.type.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }
      return _.filter(ret, (account) => {
        if(this.$is_privilege(["root", "developer"])) return true;
        if(this.$is_privilege(["admin","device_admin"]) && (account.type != "root" || account.type != "developer")) return true;
        return false;
      });
    }
  },
  mounted () {
  },
  methods: {
    open_add_account () {
      this.$router.push("/settings/accounts/new")
    },
    open_edit_account (id) {
      this.$router.push("/settings/accounts/edit/"+id)
    }
  }
}
</script>
